const isDevEnv = location?.href.startsWith('http://127.0.0.1');

function loadCustomerInfo() {
  try {
    const info = localStorage.getItem('customer-info');
    return info ? JSON.parse(info) : null;
  } catch {
    console.warn('Invalid JSON in customer-info');
    return null;
  }
}

async function fetchJson(url, options = {}) {
    const res = await fetch(url, options);
    if (!res.ok) throw new Error(`HTTP ${res.status} @ ${url}`);
    return res.json();
}

document.addEventListener("DOMContentLoaded", initCriarConta);

async function initCriarConta() {

    const registerBtn = document.querySelector(".register-btn");
    const customerTypeSelect = document.querySelector("#select-customer-type");
    const customerTypeOptions = document.querySelector(".customer-type-options");
    const customerTypeLabels = document.querySelectorAll(".customer-type-options label");
    const loaderModal = document.querySelector("#full-page-loader-modal");
    const criarContaForm = document.querySelector("#criarContaForm");
    let customerIdValue = document.querySelector("#customerId")?.value || "";
    let customerEmailValue = document.querySelector("#customer-email-value")?.value || "";
    const customerContinuarBtn = document.querySelector("#customerContinuarBtn");
    const formModal = document.querySelector("#criar-conta-popup");
    const modalText = formModal.querySelector(".modal-heading__text span");
    const emailInput = document.querySelector("#email");
    const hiddenTypeInput = document.querySelector('input[name="customer-type"]');

    const storedFields = ["nome", "apelido", "email", "phone", "customer_type", "customerId"];
    let customerTypeChanged = false;

    let customerInfo = loadCustomerInfo();

    if (customerInfo) {
        storedFields.forEach((field) => {
            const fieldElem = document.querySelector(`#${field}`);
            if (fieldElem) fieldElem.value = customerInfo[field] || "";
        });
        document.querySelector(`#email`).setAttribute("readonly", "true");
        customerIdValue = customerInfo['customerId'];
        customerEmailValue = customerInfo['email'];

        showMobileBioForm()
    }

    // handle ?page=vantagens
    if (new URLSearchParams(location?.search).get('page') == 'vantagens') {
        showMobileBioForm();
    }

    // handle reg params
    await handleRegistrationRedirects();

    //TODO: check if customer is registered

    registerBtn?.addEventListener("click", showMobileBioForm);

    customerTypeSelect?.addEventListener("click", (e) => {
        e.preventDefault();
        customerTypeOptions.style.display = "block";
    });


    customerTypeLabels.forEach((lab) => {
        lab.addEventListener('click', async (e) => {
            e.preventDefault();

            customerTypeChanged = true;

            customerTypeLabels.forEach((label) => {
                label.querySelector(".option-label")?.classList.remove("active");
            })

            lab.querySelector(".option-label")?.classList.add("active");
            const customerType = lab.dataset.type;

            customerTypeSelect.value = lab.dataset.label;
            // console.log({customerType});
            if (hiddenTypeInput) hiddenTypeInput.value = customerType;

            customerTypeOptions.style.display = "none";

        })
    });

    customerContinuarBtn?.addEventListener("click", handleSubmitCriarContaForm);

    
    function showMobileBioForm() {
        const btnSection = document.querySelector(".login-section");
        const customerBioForm = document.querySelector(".account-section");
        const progressBar = document.querySelector(".fixed-to-top");
        
        btnSection?.classList.add("hideOnMobile");
        customerBioForm?.classList.add("flexOnMobile");
        progressBar.classList.add("show");
    }

    async function handleRegistrationRedirects() {
        const regEmail        = document.querySelector('#reg_email')?.value;
        const regCustomerType = document.querySelector('#reg_customer_type')?.value;
        const regContinenteCard = document.querySelector('#reg_continente_card')?.value;
        if (!regEmail) return;

        const targetProfile = '/pages/completar-perfil';

        if (regContinenteCard && regCustomerType) {
            location.assign('/pages/a-minha-conta');
        } else {
            location.assign(targetProfile);
        }

    }
    
    async function handleSubmitCriarContaForm(e = null) {
        e?.preventDefault();
    
        try {
            
        
            const requiredFields = ["nome", "apelido", "email"];
            let isFormValid = validateBioForm(requiredFields);
        
            if (!isFormValid) {
                return false;
            }
        
            customerContinuarBtn?.setAttribute("disabled", true);
            loaderModal.show();
        
            //check phone no used
            let phoneNumber = document.querySelector("#phone")?.value;
            let phoneNumberCheck = {};
            if (phoneNumber && !(isDevEnv)) {
                if (!phoneNumber.startsWith("+351")) {
                    phoneNumber = "+351" + phoneNumber;
                }
        
                const customerRes = await fetch(`https://sonae-shopify-app.production.theloop.tech/customeridentify`, {
                    method: "POST",
                    body: JSON.stringify({data: {phoneNumber}}),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
        
                phoneNumberCheck = await customerRes.json();
            }
        
            if (
                phoneNumberCheck?.data?.data?.customerByIdentifier?.id && 
                phoneNumberCheck?.data?.data?.customerByIdentifier?.email != emailInput?.value 
            ) {
                loaderModal.hide();
                customerContinuarBtn?.removeAttribute("disabled", true);
    
                displayModalText("Tem este número de telemóvel já associado a um perfil da escola note!", 3000);
                return false;
            }
        
            //check email already registered
            let emailAddress = document.querySelector("#email")?.value;
            let emailAddressCheck = {};
            if (emailAddress && !(isDevEnv)) {
                const customerRes = await fetch(`https://sonae-shopify-app.production.theloop.tech/customeridentify`, {
                    method: "POST",
                    body: JSON.stringify({data: {email: emailAddress}}),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
        
                emailAddressCheck = await customerRes.json();
            }
        
            if (emailAddressCheck?.data?.data?.customerByIdentifier?.id) {
                loaderModal.hide();
                customerContinuarBtn?.removeAttribute("disabled", true);
    
                displayModalText("Este email já está a ser utilizado! Faz login na tua conta", 3000);
                location.assign("/account/login");
                return false;
            }
        
            let isCustomerRegistered = Boolean((customerIdValue)?.trim());
            const customerFormObj = {
                metafields: {
                    customer_type: hiddenTypeInput?.value,
                }
            };
        
            const customerFormData = new FormData(criarContaForm);
        
            customerFormData.forEach((val, key) => {
                if (requiredFields.includes(key)){
                    customerFormObj[key] = val;
                }
            });
    
    
            let customerInfo = loadCustomerInfo()
    
            if (customerInfo) {
                customerIdValue = customerInfo['customerId'];
                customerEmailValue = customerInfo['email'];
                isCustomerRegistered = true;
            }
    
            if (isCustomerRegistered) {
                customerFormObj['id'] = customerIdValue;
        
                customerFormObj['email'] = customerEmailValue;
            } else {
            
                //validate email
                const emailValidateRes = await fetch(`/apps/sonae-stores-app/customer-email-validate`, {
                    method: "POST",
                    body: JSON.stringify({ email: customerFormObj.email }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
    
                const emailValidateJson = await emailValidateRes.json();
                
                if (!emailValidateJson?.data?.valid) {
                    loaderModal.hide();
                    customerContinuarBtn?.removeAttribute("disabled", true);
                    displayModalText("O e-mail é inválido!", 3000);
                    return false;
                }
            }
        
            const customerRes = await fetch(`/apps/sonae-stores-app/customer-account?source=bazaar-noteonline.myshopify.com${isCustomerRegistered ? '&isUpdate=true' : ''}`, {
                method: "POST",
                body: JSON.stringify({data: customerFormObj}),
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then((res) => res.json())
            .catch((error) => {
                customerContinuarBtn?.removeAttribute("disabled");
                console.log(error);
            });
        
            if (customerRes){
        
                if (customerRes?.data?.success == false) {
                    loaderModal.hide();
                    let errorMessage = customerRes?.data?.message || "Erro!";
        
                    if (errorMessage.toLowerCase().includes("phone") && errorMessage.toLowerCase().includes("taken"))
                    {
                        errorMessage = "Número de telefone já utilizado";
                    }
                    if (errorMessage.toLowerCase().includes("phone") && errorMessage.toLowerCase().includes("invalid"))
                    {
                        errorMessage = "O número de telefone é inválido";
                    }
                    if (errorMessage.toLowerCase().includes("email") && errorMessage.toLowerCase().includes("taken"))
                    {
                        errorMessage = "Este email já está a ser utilizado! Faz login na tua conta!";
                        setTimeout(() => {
                            location.assign("/account/login");
                        }, 3000);
                    }
                    displayModalText(errorMessage, 3000);
                }
                else
                {
                    setTimeout(() => {
                        customerFormObj.customer_type = customerFormObj.metafields.customer_type;
                        delete customerFormObj.metafields;
                        customerFormObj["customerId"] = customerRes?.data?.customer.id.split('/').reverse()[0];
                        localStorage.setItem("customer-info", JSON.stringify(customerFormObj));
                        
                        loaderModal.hide();
                        location.assign("/pages/completar-perfil");
                    }, 1000);
                }
            }
        } catch (error) {
            console.log(error?.message);
            displayModalText(error?.message || "Erro!", 3000);
    
            loaderModal.hide();
        }
    
        customerContinuarBtn?.removeAttribute("disabled");
    }
    
    function validateBioForm (requiredFields = []) {
        let isFormValid = true;
        const consentCheckbox = document.querySelector("#data-consent");
    
        // validate required inputs
        requiredFields.forEach((field) => {
            const element = document.querySelector(`input[name=${field}]`);
            if (element && !element.value) {
                isFormValid = false;
                element.classList.add("input-error");
                //remove class when changed
                element.addEventListener("focusout", (e) => {
                    let val = e.target.value;
                    if (val) {
                        element.classList.remove("input-error");
                    }
                });
            }
        });
    
        if (!customerTypeChanged) {
            isFormValid = false;
            document.querySelector(`select[name=eu-sou]`)?.classList.add("input-error");
        }
    
        if (!consentCheckbox?.checked) {
            displayModalText("Para efeitos de inscrição no Programa Escola Note! necessitamos do teu consentimento.", 3000);
    
            isFormValid = false;
        }
        return isFormValid;
    }
    
    function displayModalText(text, duration = 3000) {
        modalText.innerHTML = text;
        formModal?.show();
        setTimeout(() => {
            formModal?.hide();
        }, duration);
    }
}
